import { httpTicketCheck, httpV2Backend } from './http';
import gameHeaders from './headers';

export default {
  getEndpoint(platformName, config) {
    const appName = config.applicationName === 'Terminal' ? 'TERMINAL' : 'WEB';
    const platform = platformName ? platformName.toUpperCase() : 'SEVEN';
    const { ngsTicketCheck } = config.ui.config;

    const path = ngsTicketCheck
      ? `VUE_APP_NGS_${appName}_TICKET_CHECK_PATH`
      : `VUE_APP_${platform}_${appName}_TICKET_CHECK_PATH`;

    return process.env[path];
  },
  check(config, user, requestUuid) {
    const { platformName, productName } = config;
    const url = this.getEndpoint(platformName, config);
    const { ngsTicketCheck } = config.ui.config;

    const authHeaders = gameHeaders.getAuthHeader(user, config);
    const platformHeaders = ngsTicketCheck
      ? gameHeaders.getNgsHeaders(config, user)
      : gameHeaders.getPlatformHeaders(user, config, requestUuid);
    const headers = { ...authHeaders, ...platformHeaders };

    const endpoint = ngsTicketCheck
      ? `${url}/${requestUuid}?product=${productName}`
      : `${url}/${requestUuid}/product/${productName}/check.json`;

    return httpTicketCheck(config).get(endpoint, { headers });
  },
  checkByProviderBetslipId(config, user, providerBetslipId) {
    const { platformName, productName } = config;
    const url = this.interpolateUrl(
      this.getEndpoint(platformName, config),
      { requestUuid: providerBetslipId },
    );
    const headers = {
      ...gameHeaders.getAuthHeader(user, config),
      ...gameHeaders.getPlatformHeaders(user, config, providerBetslipId),
    };

    return httpTicketCheck(config).get(`${url}?product=${productName}`, { headers });
  },
  checkV2TicketByRequestUuid(config, requestId) {
    const { tenantId } = config;
    const route = config.applicationName === 'Terminal' ? 'tickets' : 'online-tickets';
    return httpV2Backend(config.productName).get(`/${route}/tenants/${tenantId}/requests/${requestId}`);
  },
  checkV2TicketByBarcode(config, barcode) {
    const { tenantId } = config;
    return httpV2Backend(config.productName).get(`/tickets/tenants/${tenantId}/barcodes/${barcode}`);
  },
  interpolateUrl(url, config) {
    return url.replace(/{([^}]+)}/g, (match, key) => (Object.prototype.hasOwnProperty.call(config, key) ? config[key] : match));
  },
};
